import { produce } from "immer";
import { deleteCookie } from "./utils/utils";

const getSourceMarketplace = (store = {}) => {
  if (store.source_marketplace) return store.source_marketplace;
  if (Array.isArray(store.channels)) return store.channels[0] || "";
  return Object.keys(store.channels || {})[0] || "";
};

export const initialState = {
  userData: {},
  fetchingWorkspaces: false,
  workspaces: [],
  selectedWorkspace: {},
  fetchingStores: false,
  stores: [],
  fetchingSelectedStore: false,
  selectedStore: {
    source_marketplace: {},
  },
  acceptedStoreValues: {},
  version: "0.17.0",
  userRole: {
    loading: false,
  },
  workspaceUsers: {},
  username: {},
  indexedDbProducts: null,
  offlineIDB: null,
  tempIDB: null,
  featureFlags: {},
  loadingFeatureFlags: true,
  userPreferences: {},
  appVersion: "",
};

/* eslint-disable default-case, no-param-reassign */
const globalReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // case "SET_VERSION":
      //   draft.version = "v" + action.payload;
      case "ON_LOGOUT":
        window.localStorage.removeItem("userData");
        window.localStorage.removeItem("deviceId");

        draft.userData = {};
        // window.location.href = "/login";
        break;
      case "ON_LOGIN":
        if (action.payload && action.payload._id) {
          draft.userData = action.payload;
        }
        break;
      case "FETCH_USER_PROFILE_SUCCESS":
        if (action.payload.data) {
          if (action.payload.data.userPreferences) {
            draft.userPreferences = action.payload.data.userPreferences;
          }
          draft.userData = action.payload.data;
        }
        break;
      case "INDEXED_DB":
        draft.indexedDbProducts = action.payload.indexedDbProducts;
        draft.offlineIDB = action.payload.offlineIDB;
        draft.tempIDB = action.payload.tempIDB;
        break;

      case "COLLAPSE_LEFT_MENU":
        draft.userPreferences = {
          ...draft.userPreferences,
          sidebarIsCollapsed: action.payload,
        };
        break;
      case "FETCH_UPDATE_PROFILE_SUCCESS":
        if (action.payload && action.payload.data && action.payload.data._id) {
          const updatedUserData = draft.userData;
          updatedUserData["lastActiveWorkspaceId"] =
            action.payload.data.lastActiveWorkspaceId;
          updatedUserData["lastActiveStoreId"] =
            action.payload.data.lastActiveStoreId;

          // Below code is to remove old store and resource acl data
          delete updatedUserData["resourceACL"];
          delete updatedUserData["storeACL"];
          if (action.payload.data.userPreferences) {
            draft.userPreferences = action.payload.data.userPreferences;
          }
          draft.userData = { ...updatedUserData, ...action.payload.data };
        }
        break;
      case "FETCH_WORKSPACES_REQUEST":
        draft.fetchingWorkspaces = true;
        // draft.fetchingStores = true;
        break;
      case "FETCH_WORKSPACES_SUCCESS":
        if (action.payload.data && action.payload.data.length > 0) {
          draft.workspaces = action.payload.data;
        }
        draft.fetchingWorkspaces = false;
        break;
      case "FETCH_WORKSPACES_ERROR":
        draft.fetchingWorkspaces = false;
        break;
      case "UPDATE_SELECTED_WORKSPACE":
        let imageUrl = action.payload.imageUrl;
        if (action.payload.imageUrl) {
          if (action.payload.imageUrl) {
            imageUrl = action.payload.imageUrl.replace("http:", "https:");
          }
        }
        draft.selectedWorkspace = { ...action.payload, imageUrl } || {};
        break;
      case "FETCH_STORES_REQUEST":
        draft.fetchingStores = true;
        draft.stores = [];
        break;
      case "FETCH_STORES_SUCCESS":
        if (action.payload.data) {
          draft.stores = action.payload.data;
        }
        draft.fetchingStores = false;
        break;
      case "FETCH_STORES_ERROR":
        draft.fetchingStores = false;
        break;
      case "FETCH_SELECTED_STORE_REQUEST":
        draft.fetchingSelectedStore = true;
        break;
      case "FETCH_SELECTED_STORE_SUCCESS": {
        const sourceMarketplace = getSourceMarketplace(action.payload.data);
        let resources =
          action.payload.data && action.payload.data.resources
            ? [action.payload.data.resources].flat(Infinity)
            : [];
        let temp = [];
        resources.forEach((resource) => {
          if (!temp.find((item) => item.name == resource.name)) {
            temp.push(resource);
          }
        });
        resources = temp;
        const smpVersion =
          action.payload.data &&
          action.payload.data.channels &&
          action.payload.data.channels[sourceMarketplace];
        const channels =
          (action.payload.data &&
            action.payload.data.channels &&
            Object.keys(action.payload.data.channels)) ||
          [];
        const storeWebsite = action.payload.data.store_website;
        const channelsWithVersion = action.payload.data
          ? action.payload.data.channels
          : [];
        if (action.payload.data) {
          draft.selectedStore = {
            ...action.payload.data,
            channels,
            smpVersion,
            channelsWithVersion,
            resources: resources,
            source_marketplace: sourceMarketplace,
            storeWebsite,
            // source_marketplace:
            //   action.payload.data.source_marketplace || DEFAULT_SOURCE_MP,
            locked: draft.selectedStore.locked,
          };
        }
        draft.fetchingSelectedStore = false;
        break;
      }
      case "FETCH_SELECTED_STORE_ERROR":
        draft.fetchingSelectedStore = false;
        break;
      case "UPDATE_SELECTED_STORE":
        draft.selectedStore = action.payload
          ? {
              ...action.payload,
              channels: action.payload.channels
                ? Array.isArray(action.payload.channels)
                  ? action.payload.channels
                  : Object.keys(action.payload.channels)
                : [],
              smpVersion: draft.selectedStore.smpVersion,
              source_marketplace: getSourceMarketplace(action.payload),
              storeWebsite:
                action.payload.store_website || action.payload.storeWebsite || "",
            }
          : {
              source_marketplace: "",
            };
        break;
      case "UPDATE_STORE_LOCKED":
        draft.selectedStore = {
          ...draft.selectedStore,
          locked: true,
          source_marketplace: getSourceMarketplace(draft.selectedStore),
        };
        break;
      case "SET_ACCEPTED_STORE_VALUES":
        let values = {};
        if (action.payload) {
          values = {
            ...action.payload,
            channels: action.payload.channels
              ? action.payload.channels.sort()
              : [],
          };
        }
        draft.acceptedStoreValues = values;
        break;
      case "FETCH_USER_ROLE_REQUEST":
        draft.userRole.loading = true;
        break;
      case "FETCH_USER_ROLE_SUCCESS":
        if (action.payload.data) {
          draft.userRole = {
            loading: false,
            ...action.payload.data,
          };
        }
        break;
      case "FETCH_USER_ROLE_ERROR":
        draft.userRole = { loading: false };
        break;

      case "FETCH_APP_VERSION_SUCCESS":
        draft.appVersion = action.payload.data?.currentVersion || "";
        break;

      case "FETCH_USER_NAME_SUCCESS":
        draft.username = action.payload.data;
        break;
      case "FETCH_WORKSPACE_USER_NAME_SUCCESS":
        draft.workspaceUsers = action.payload.data;
        break;
      case "FETCH_UPDATE_SELECTED_STORE_MAPPINGS_SUCCESS":
        draft.selectedStore.mappings = action.payload.data.mappings;
        break;
      case "FETCH_FEATURE_FLAGS_REQUEST":
        draft.loadingFeatureFlags = true;
        break;

      case "FETCH_FEATURE_FLAGS_SUCCESS":
        if (action.payload && action.payload.data)
          draft.featureFlags = action.payload.data;
        draft.loadingFeatureFlags = false;
        break;

      case "FETCH_FEATURE_FLAGS_ERROR":
        draft.loadingFeatureFlags = false;
        break;
    }
  });

export default globalReducer;
